import { NextComponentType } from "next"
import React from "react"
import FullscreenLoading from "../common/FullscreenLoading"

interface Props {
    displayPreloading: boolean
}

// eslint-disable-next-line @typescript-eslint/ban-types
const withDisplayPreloading = <P extends {}>(WrappedComponent: NextComponentType<P>) => {
    class WithDisplayPreloadingHOC extends React.PureComponent<P & Props> {
        static getInitialProps

        render() {
            const { displayPreloading } = this.props
            return displayPreloading ? <FullscreenLoading /> : <WrappedComponent {...this.props} />
        }
    }

    if (WrappedComponent.getInitialProps) {
        WithDisplayPreloadingHOC.getInitialProps = WrappedComponent.getInitialProps
    }

    return WithDisplayPreloadingHOC
}

export default withDisplayPreloading
